
export default {
  whiteDepts: [],
  chnl: 0,
  total:0,
  max:10,
  offset:0,
  sort: 'dept.name',
  order: 'ascending'
};
